import { windowService } from 'tw-framework'
import { messageService } from 'tw-ui'

export default class home_controller  {
    constructor(props, context, route) {
        this.props = props
        this.context = context
        this.route = route
    }
    applyForTrial() {
        windowService.showDialog('apply_for_trial').then(() => {
            // 对话框已调用申请接口，此处不用处理，在对话框调用是为了防止校验不通过时关闭了对话框
        }).catch(err => {
            if (err) {
                messageService.error(err.message)
            }
        })
    }
    click_3f287d29_ed18() {
        window.open('https://tinwayerp.com/workshow/main')
    }
}